import { Box, CircularProgress, Typography } from '@mui/material';

interface LoadingScreenProps {
    message?: string;
}

function LoadingScreen({ message = "Loading..." }: LoadingScreenProps) {
    return (
        <Box sx={{
            margin: '0 auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '200px',
            height: '200px'
        }}>
            <Typography align="center" variant="h6">{message}</Typography>
            <Box sx={{ ml: 2 }}>
                <CircularProgress />
            </Box>
        </Box>
    );
}

export default LoadingScreen;
